(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/search-filters/assets/javascripts/search-filter-product-button.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/search-filters/assets/javascripts/search-filter-product-button.js'); "use strict";


const {
  useContext
} = React;
const {
  clx
} = svs.components.lbUtils.clx;
const {
  MarketplaceBrand,
  MarketplaceBrandContext
} = svs.components.marketplace.marketplaceBrand;
const FilterProductButton = _ref => {
  let {
    productId,
    isActive,
    onClick = () => {},
    children
  } = _ref;
  const {
    getBrandedDisplayName
  } = useContext(MarketplaceBrandContext);
  const label = getBrandedDisplayName(productId);
  return (
    React.createElement("button", {
      className: clx('filter-product', 'qa-filter-product', {
        'is-active': isActive
      }),
      key: label,
      onClick: onClick,
      type: "button"
    }, React.createElement("span", {
      className: "filter-product-brand"
    }, React.createElement(MarketplaceBrand, {
      productId: productId,
      square: true
    })), React.createElement("span", {
      className: "filter-product-name"
    }, React.createElement("span", {
      className: "filter-product-name-row-label"
    }, label), React.createElement("span", {
      className: "filter-product-name-row"
    }, children)))
  );
};
setGlobal('svs.components.marketplaceShared.searchFilters.FilterProductButton', FilterProductButton);
 })(window);